import { format } from 'date-fns';
import actionTypes from '../actions/actionTypes';

export const INITIAL_STATE = {
  loading: false,
  error: false,
  data: {
    netSales: 0,
    goal: 0,
    mps: 0,
    salesThrough: '',
  },
};

const associateScorecardReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actionTypes.ASSOCIATE_MY_SCORECARD_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case actionTypes.ASSOCIATE_MY_SCORECARD_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
      };
    case actionTypes.ASSOCIATE_MY_SCORECARD_SUCCESS:
      return {
        ...state,
        loading: false,
        data: {
          ...state.data,
          ...{
            netSales: payload.netSales || 0,
            goal: payload.goal || 0,
            mps: payload.mps || 0,
            salesThrough: payload.validThrough ? format(new Date(payload.validThrough), 'MM/dd/yyyy') : '',
          },
        },
      };
    default:
      return state;
  }
};

export default associateScorecardReducer;
